<template>
    <div>
        <sunrise v-if="open" class="animated bounceInUp"></sunrise>
        <div class="trees-container"
        :class="{'open': open}">
            <img v-if="percentage >= 0" id="tree1" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
            <img v-if="percentage >= 15" id="tree2" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
            <img v-if="percentage >= 26" id="tree3" class="spawned-tree img-responsive" src="../assets/dark-tree.svg" />
            <img v-if="percentage >= 36" id="tree4" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
            <img v-if="percentage >= 46" id="tree5" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
            <img v-if="percentage >= 53" id="tree6" class="spawned-tree img-responsive" src="../assets/dark-tree.svg" />
            <img v-if="percentage >= 58" id="tree7" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
            <img v-if="percentage >= 68" id="tree8" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
            <img v-if="percentage >= 76" id="tree9" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
            <img v-if="percentage >= 86" id="tree10" class="spawned-tree img-responsive" src="../assets/dark-tree.svg" />
            <img v-if="percentage >= 95" id="tree11" class="spawned-tree img-responsive" src="../assets/light-tree.svg" />
            <img v-if="open" id="sprout1" class="sprout spawned-tree img-responsive" src="../assets/sprout.svg" />
            <img v-if="open" id="sprout2" class="sprout spawned-tree img-responsive" src="../assets/sprout.svg" />
            <img v-if="open" id="sprout3" class="sprout spawned-tree img-responsive" src="../assets/sprout.svg" />
            <img v-if="open" id="sprout4" class="sprout spawned-tree img-responsive" src="../assets/sprout.svg" />
            <img v-if="open" id="sprout5" class="sprout spawned-tree img-responsive" src="../assets/sprout.svg" />
            <img v-if="open" id="bush1" class="sprout spawned-tree img-responsive" src="../assets/bush.svg" />
            <img v-if="open" id="bush2" class="sprout spawned-tree img-responsive" src="../assets/bush.svg" />
            <img v-if="open" id="bush3" class="sprout spawned-tree img-responsive" src="../assets/bush.svg" />
            <img v-if="open" id="bush4" class="sprout spawned-tree img-responsive" src="../assets/bush.svg" />
            <!-- <img v-if="open" id="sprout6" class="spawned-tree img-responsive" src="../assets/sprout.svg" /> -->
        </div>
        <div class="progress">
            <div class="progress-bar" style="width:70%"
            :style="progressbarStyle">{{progressbarStyle.width}}</div>
        </div>
        <div class="lvl-text" v-html="this.$locale.head.level +': ' + lvl">Lvl:{{lvl}}</div>
        <div class="goal-text" v-html="this.$locale.head.goal +': ' + goal+' »'">Goal:{{goal}} »</div>
    </div>
</template>
<script>
import Sunrise from "./Sunrise.vue";

export default {
    props:["progress", "goal", "lvl", "open"],
    data(){
        return{
            progressbarStyle:{
                width: '0%'
            },
            percentage: undefined 
        }
    },
    created(){
        /* eslint-disable no-console*/
        
    },
    mounted(){
        if(this.progress || this.progress == 0){
            this.percentage = (this.progress < this.goal) ? Math.floor(this.progress / this.goal * 100) : 100;
            this.progressbarStyle.width = this.percentage + '%'
        }
    },
    watch:{
        progress: {
            handler(val){
                if(val){
                    this.percentage = (val < this.goal) ? Math.floor(val / this.goal * 100) : 100
                    this.progressbarStyle.width = this.percentage + '%'
                }
            }
        },
        goal: {
            handler(val){
                if(val && this.progress <= val){
                    this.percentage = (this.progress < this.goal) ? Math.floor(this.progress / val * 100) : 100
                    this.progressbarStyle.width = this.percentage + '%'
                }
            }
        },
    },
    components: {
        Sunrise
    }
    // methods: {
    //     randomMargin: function(){
    //         var margin = Math.random() * 0.6 + 0.002;
    //         console.log(margin);
    //         return margin +'rem';
    //     }
    // }
}
</script>
<style scoped lang="scss">
    .progress{
        background-color: var(--light-blu)!important;
        height: 1.3rem;
        border-radius: 0%;
    }
    .progress-bar{
        background-color: var(--dark-blu)!important;
    }
    .goal-text{
        text-align: right;
        margin-right: 1rem;
    }
    .lvl-text{
        text-align: left;
        margin-left: 1rem;
        float: left;
    }
    .spawned-tree{
        /* margin-left: 0.5rem;
        margin-right: 0.5rem; */
        width: 2rem;
    }

    .open > .spawned-tree{
        // position: absolute!important;
        transition: all .3s cubic-bezier(.6,0,.45,1.3);
    }

    .trees-container{
        height:3.6rem;
        transition: all .3s cubic-bezier(.6,0,.45,1.3);
        // z-index: 1;

        &.open{
            // height: 300px;
            height: 18.75rem;
            transition: all .3s cubic-bezier(.6,0,.45,1.3);
            background-image: url("../assets/forest-ground.svg");
            background-repeat: no-repeat;
            background-size: cover;
        }
    }

    .spawned-tree{
    transform-origin:50% 100%;
    -moz-transform-origin:50% 100%;
    animation: appear 1s 1, grow 3s infinite;
    transform-box: fill-box;
    animation-timing-function: cubic-bezier(.63,.09,.3,1.43);
    animation-fill-mode:forwards;
    transform:scale(0);
    // position:relative;
    position:absolute;
    transition: all .5s cubic-bezier(.6,0,.45,1.3);
  }
  
.sprout{
    position: absolute;
    max-width: 1.5rem;
    // animation: grow 2s infinite;
}
#sprout1{
    left:50%;
    // top:7rem;
    top: 16rem;
    animation-delay: 0s, 1s;
}
#sprout2{
    right:25%;
    top:14rem;
    animation-delay: 0.3s, 1.3s;
}
#sprout3{
    left: 20%;
    top: 19rem;
    animation-delay: 0.6s, 1.6s;
}
#sprout4{
    right: 10%;
    top: 21rem;
    animation-delay: 0.6s, 1.7s;
}
#sprout4{
    right: 10%;
    top: 21rem;
    animation-delay: 0.6s, 2;
}
#sprout5{
    left: 5%;
    top: 12rem;
    animation-delay: 0.9s, 1.9s;
}
#bush1{
    left:19%;
    // top:10rem;
    top: 14.5rem;
    animation-delay: 0.1s, 1.1s;
}
#bush2{
    right:16%;
    // top:9rem;
    top: 15rem;
    z-index: 0;
    animation-delay: 0.3s, 1.3s;
}
#bush3{
    left: 40%;
    top: 18rem;
    animation-delay: 0.6s, 1.6s;
}
#bush4{
    right: 23%;
    top: 23rem;
    animation-delay: 0.6s, 1.7s;
}


/*Keyframes*/
@keyframes appear {
    0%   {transform:scaleX(0) scaleY(0) translateY(0)}
    70%  {transform:scaleX(0.7) scaleY(0.7) translateY(0)}
    80%  {transform:scaleX(0.9) scaleY(0.5) translateY(5px)}
    100% {transform:scaleX(1) scaleY(1) translateY(0)}
}

/*Keyframes*/
@keyframes grow {
    0% {transform:scaleX(1) scaleY(1) translateY(0)}
    50%  {transform:scaleX(0.95) scaleY(0.9) translateY(1px)}
    100% {transform:scaleX(1) scaleY(1) translateY(0)}
}

        #tree1{
            // margin-left: 0.5rem;
            // margin-bottom: 0.5rem;
            top: 6.9rem;
            left: 2%;
            animation-delay: 0s, 1s;
            .open &{
                left: 22%; 
                top: 16rem; 
            }
        }
        #tree2{
            // margin-left: 0.5rem;
            // margin-bottom: 0.2rem;
            top: 7.2rem;
            left: 12%;
            // right:auto;
            animation-delay: 0.3s, 1.3s;
            .open &{
                // left: auto;
                // right: 22%;
                left: 70%; 
                top: 18rem; 
            }
        }
        #tree3{
            // margin-left: 0.5rem;
            // margin-bottom: 0.4rem;
            top: 7rem;
            left: 22%;
            animation-delay: 0.6s, 1.6s; 
            .open &{
                left: 40%; 
                top: 10rem; 
            }
        }
        #tree4{
            // margin-left: 0.5rem;
            // margin-bottom: 0.6rem;
            top: 6.8rem;
            left: 32%;
            // right:auto;
            animation-delay: 0.9s, 1.9s;
            .open &{
                // right: 35%; 
                left: 57%;
                top: 13rem;
                // left: auto; 
            }
        }
        #tree5{
            // margin-left: 0.7rem;
            // margin-bottom: 0.1rem;
            top: 7.3rem;
            left: 42%;
            animation-delay: 1.2s, 2.2s;
            .open &{
                left: 14%;
                // top: 7rem;
                top: 11rem;
            }
        }
        #tree6{
            // margin-left: -0.3rem;
            // margin-bottom: 0.7rem;
            top: 6.7rem;
            right: 43%;
            animation-delay: 1.5s, 2.5s;
            .open &{
                top: 21rem; 
            }
        }
        #tree7{
            // margin-left: -0.6rem;
            // margin-bottom: 0.2rem;
            top: 7.2rem;
            right: 37%;
            // left:auto;
            animation-delay: 1.8s, 2.8s;
            .open &{
                // right: auto;
                // left: 2%;
                right: 90%;
                top: 20rem;
            }
        }
        #tree8{
            // margin-left: 0.5rem;
            // margin-bottom: 0.7rem;
            top: 6.7rem;
            right: 28%;
            animation-delay: 2.1s, 3.1s;
            .open &{
                right: 7%;
                top: 11rem;
            }
        }
        #tree9{
            // margin-left: 0.1rem;
            // margin-bottom: 0.5rem;
            top: 6.9rem;
            right: 20%;
            // left:auto;
            animation-delay: 2.4s, 3.4s;
            .open &{
                // right: auto;
                // left: 32%;
                right: 60%;
                // top: 6rem;
                top: 13rem;
            }
        }
        #tree10{
            // margin-left: 0.6rem;
            // margin-bottom: 0.2rem;
            top: 7.2rem;
            right: 11%;
            animation-delay: 2.7s, 3.7s;
            .open &{
                right: 10%;
                // top: 6rem;
                top: 15rem;
                z-index: 1;
            }
        }
        #tree11{
            // margin-left: 0.3rem;
            // margin-bottom: 0.6rem;
            top: 6.8rem;
            right: 2%;
            animation-delay: 3s, 4s;
            .open &{
                right: 30%;
                // top: 15%;
                top: 9.5rem;
            }
        }
        #special-tree{
            .open &{
                left: 45.8%; 
                top: 12rem; 
            }
        }
</style>